/**
 * Roofing nail SVG — slightly angled, raw industrial, amber.
 * Used in Process step 3 as the unexpected design move.
 */
export default function RoofingNail({ className = "", size = 180 }) {
  return (
    <svg
      data-testid="roofing-nail-graphic"
      className={className}
      width={size}
      height={size}
      viewBox="0 0 200 200"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Roofing nail"
    >
      <g transform="rotate(-22 100 100)">
        {/* Head — flat, wide, hammered look */}
        <ellipse cx="100" cy="42" rx="44" ry="10" fill="#d97706" />
        <ellipse cx="100" cy="40" rx="44" ry="10" fill="#f59e0b" />
        {/* Head top highlight */}
        <ellipse cx="92" cy="36" rx="22" ry="3" fill="#fbbf24" opacity="0.85" />
        {/* Hammer dents */}
        <circle cx="84" cy="40" r="2.2" fill="#b45309" opacity="0.7" />
        <circle cx="108" cy="38" r="1.6" fill="#b45309" opacity="0.6" />
        <circle cx="118" cy="42" r="2" fill="#b45309" opacity="0.55" />

        {/* Shaft — tapered */}
        <path
          d="M 78 50 L 122 50 L 112 168 L 88 168 Z"
          fill="#d97706"
        />
        <path
          d="M 78 50 L 122 50 L 116 78 L 84 78 Z"
          fill="#f59e0b"
        />
        {/* Shaft highlight */}
        <path
          d="M 84 52 L 92 52 L 90 162 L 86 162 Z"
          fill="#fbbf24"
          opacity="0.55"
        />
        {/* Shaft shadow */}
        <path
          d="M 116 52 L 122 52 L 112 168 L 108 168 Z"
          fill="#92400e"
          opacity="0.6"
        />

        {/* Tip — sharp point */}
        <path
          d="M 88 168 L 112 168 L 100 192 Z"
          fill="#b45309"
        />
        <path
          d="M 88 168 L 100 168 L 100 192 Z"
          fill="#d97706"
        />
      </g>
    </svg>
  );
}
